import React, { useEffect, useState, useContext } from "react";

import { DateFormat, getApi } from "../../../helpers";
import Badge from "../../../components/Badge";
import CardContainer from "../../../components/Card";
import TableContainer from "../../../components/Table";
import PaymentSidebar from "../Sidebar";
import { StoreContext } from "../../../context";

const mainColumns = [
  {
    title: "Order Id",
    dataIndex: "order_id",
    key: "order_id",
    sorter: true,
  },
  {
    title: "Store",
    dataIndex: "store_name",
    key: "store_name",
  },
  {
    title: "Customer Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Customer Mobile",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "Method",
    dataIndex: "payment_type",
    key: "payment_type",
    render: (text) => (
      <div style={{ textTransform: "capitalize" }}>{text ? text : "NA"}</div>
    ),
    sorter: true,
  },
  {
    title: "Status",
    dataIndex: "payment_status",
    key: "payment_status",
    align: "center",
    render: (text) => <Badge paymentStatus={text} />,
    sorter: true,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: (text) => (
      <div style={{ textAlign: "right" }}>₹ {text ? text : 0}</div>
    ),
    sorter: true,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateFormat(text),
    sorter: true,
  },
];

const storeColumns = [
  {
    title: "Order Id",
    dataIndex: "order_id",
    key: "order_id",
    sorter: true,
  },
  {
    title: "Customer Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Customer Mobile",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: "Method",
    dataIndex: "payment_type",
    key: "payment_type",
    render: (text) => (
      <div style={{ textTransform: "capitalize" }}>{text ? text : "NA"}</div>
    ),
    sorter: true,
  },
  {
    title: "Status",
    dataIndex: "payment_status",
    key: "payment_status",
    align: "center",
    render: (text) => <Badge paymentStatus={text} />,
    sorter: true,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: (text) => (
      <div style={{ textAlign: "right" }}>₹ {text ? text : 0}</div>
    ),
    sorter: true,
  },
  {
    title: "Date",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
    render: (text) => DateFormat(text),
    sorter: true,
  },
];

export default function AllPayments() {
  const { storeId } = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const [savedPayload, setSavedPayload] = useState({});
  const [total, setTotal] = useState(8);
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState({});
  const [sidebar, setSidebar] = useState(false);

  useEffect(() => getList(savedPayload), [storeId]);

  const getList = async (payload = {}) => {
    setLoading(true);
    if (storeId) payload = { ...payload, store_id: storeId };
    else delete payload.store_id;
    const res = await getApi(payload, "getPayments");
    if (res.data) {
      setList(res.data);
      setTotal(res.meta?.total);
    }
    setSavedPayload(payload);
    setLoading(false);
  };

  return (
    <>
      <PaymentSidebar
        visible={sidebar}
        onClose={() => {
          console.log('Closing payment sidebar');
          setSidebar(false);
        }}
        data={selected}
      />
      <CardContainer hoverable={false}>
        <TableContainer
          breadcrumbTitle="Payment Management"
          loading={loading}
          columns={storeId ? storeColumns : mainColumns}
          data={list}
          total={total}
          dateRangePicker
          searchFor="Customer, Mobile"
          rowClickHandler={(record) => {
            setSelected(record);
            setSidebar(true);
          }}
          functionsHandler={getList}
          tagFilterOptions={[
            { label: "Initiated", value: "created" },
            { label: "Received", value: "captured" },
            { label: "Refunded", value: "refunded" },
          ]}
        />
      </CardContainer>
    </>
  );
}
